import React, { memo, useState, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import i18next from "i18next";
import { Menu, MenuItem } from "@material-ui/core";
import avatar from "../../../common/images/defaultAvatar.png";
import { emoji } from "../../../common/emoji";
import { renderTime } from "../../../utils";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { EaseLivestreamContext } from "../index";
import streamerIcon from '../../../common/images/streamer.png';
import moderatorIcon from '../../../common/images/moderator.png';
import muteIcon from '../../../common/images/mute.png';
import { height } from "@mui/system";
var useStyles = makeStyles(function (theme) {
  return {
    pulldownListItem: {
      display: "flex",
      listStyle: "none",
      marginBottom: "16px",
      position: "relative" // alignItems: "center",

    },
    userName: {
      padding: "0 10px",
      fontFamily: "Roboto",
      fontWeight: "400",
      fontStyle: "normal",
      color: "#a5a5a5",
      fontSize: "12px",
      display: "inline-block",
      textAlign: "left",
      lineHeight: "14px"
    },
    textBodyBox: {
      display: "flex",
      flexDirection: "column",
      maxWidth: "80%",
      alignItems: "unset",
      wordBreak: "break-word"
    },
    textBody: {
      padding: "0 10px",
      fontFamily: "Roboto",
      fontWeight: "600",
      fontStyle: "normal",
      fontSize: "16px",
      lineHeight: "22px",
      letterSpacing: "0.15px"
    },
    time: {
      position: "absolute",
      fontSize: "11px",
      height: "16px",
      color: "rgba(1, 1, 1, .2)",
      lineHeight: "16px",
      textAlign: "center",
      top: "-18px",
      width: "100%"
    },
    read: {
      fontSize: "10px",
      color: "rgba(0,0,0,.15)",
      margin: "3px"
    },
    avatarStyle: {
      height: "28px",
      width: "28px",
      borderRadius: "50%"
    },
    userInfoBox: {
      display: "flex",
      alignItems: "center",
      height: "14px"
    },
    iconStyle: {
      width: "38px"
    },
    muteIconStyle: {
      width: "12px",
      marginLeft: "4px"
    }
  };
});

function TextMessage(_ref) {
  var _roomUserInfo$message, _roomUserInfo$message2, _roomUserInfo$message3, _roomUserInfo$message4, _roomUserInfo$message5;

  var message = _ref.message;
  var easeLivestreamProps = useContext(EaseLivestreamContext);
  var roomUserInfo = easeLivestreamProps.roomUserInfo;
  var classes = useStyles({
    bySelf: message.bySelf,
    chatType: message.chatType
  });

  var _useState = useState(""),
      copyMsgVal = _useState[0],
      setCopyMsgVal = _useState[1];

  useEffect(function () {
    setCopyMsgVal(message.msg);
  }, [copyMsgVal]);

  var renderTxt = function renderTxt(txt) {
    if (txt === undefined) {
      return [];
    }

    var rnTxt = [];
    var match = null;
    var regex = /(\[.*?\])/g;
    var start = 0;
    var index = 0;

    while (match = regex.exec(txt)) {
      index = match.index;

      if (index > start) {
        rnTxt.push(txt.substring(start, index));
      }

      if (match[1] in emoji.map) {
        var v = emoji.map[match[1]];
        rnTxt.push( /*#__PURE__*/React.createElement("img", {
          key: v,
          alt: v,
          src: require("../../../common/faces/" + v),
          width: 20,
          height: 20
        }));
      } else {
        rnTxt.push(match[1]);
      }

      start = index + match[1].length;
    }

    rnTxt.push(txt.substring(start, txt.length));
    return rnTxt;
  };

  return /*#__PURE__*/React.createElement("li", {
    className: classes.pulldownListItem
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    className: classes.avatarStyle,
    src: roomUserInfo && ((_roomUserInfo$message = roomUserInfo[message.from]) === null || _roomUserInfo$message === void 0 ? void 0 : _roomUserInfo$message.avatar) || avatar
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textBodyBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.userInfoBox
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.userName
  }, roomUserInfo && ((_roomUserInfo$message2 = roomUserInfo[message.from]) === null || _roomUserInfo$message2 === void 0 ? void 0 : _roomUserInfo$message2.nickname) || message.from), ((_roomUserInfo$message3 = roomUserInfo[message.from]) === null || _roomUserInfo$message3 === void 0 ? void 0 : _roomUserInfo$message3.isStreamer) && /*#__PURE__*/React.createElement("img", {
    src: streamerIcon,
    alt: "",
    className: classes.iconStyle
  }), ((_roomUserInfo$message4 = roomUserInfo[message.from]) === null || _roomUserInfo$message4 === void 0 ? void 0 : _roomUserInfo$message4.isAdmin) && /*#__PURE__*/React.createElement("img", {
    src: moderatorIcon,
    alt: "",
    className: classes.iconStyle
  }), ((_roomUserInfo$message5 = roomUserInfo[message.from]) === null || _roomUserInfo$message5 === void 0 ? void 0 : _roomUserInfo$message5.isMuted) && /*#__PURE__*/React.createElement("img", {
    src: muteIcon,
    alt: "",
    className: classes.muteIconStyle
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textBody
  }, renderTxt(message.body.msg))));
}

export default memo(TextMessage);